import React, { FC } from "react";
import { IFormItem } from "../Types";
import { Form, Input } from "antd";

export const __FormInput: FC<IFormItem> = (props) => {
    let { onInputBlur } = props;
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            hidden={props.hidden}
            labelCol={props.labelCol}
        >
            <Input
                disabled={props.disable ?? false}
                allowClear={props.allowClear}
                onBlur={(e) => onInputBlur?.(e)}
            />
        </Form.Item>
    )
}